import React from 'react';
import { useRecordContext } from 'react-admin';

const NOMES_ANDAR = ['Térreo', '1º Aéreo', '2º Aéreo'];

function getNomeAndar(andar) {
  return NOMES_ANDAR[andar - 1] || `Andar ${andar}`;
}

const AndarField = (props) => {
  const record = useRecordContext(props);
  const andar = record
    ? record.record
      ? record.record.andarProduto
        ? record.record.andarProduto.andar
        : null
      : null
    : null;

  return <span>{andar ? getNomeAndar(andar) : ''}</span>;
};

export default AndarField;
